// extracted by mini-css-extract-plugin
export var button = "ImmersivePictureCard-module--button--5b482";
export var content = "ImmersivePictureCard-module--content--19625";
export var title = "ImmersivePictureCard-module--title--bf561";
export var wrapper = "ImmersivePictureCard-module--wrapper--8563b";